import { Outlet, Link } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <nav>
        <ul>
          <li>
            <Link className="App-link" to="/">Skak score</Link>
          </li>
          <li>
            <Link className="App-link" to="/results">Resultater</Link>
          </li>
          <li>
            <Link className="App-link" to="/contact">Kontakt</Link>
          </li>
          <li>
            <Link className="App-link" to="/skak-list">List skak results</Link>
          </li>
        </ul>

        <ul>
          <li>
            <Link to="/note-list">List Notes</Link>
          </li>
          <li>
            <Link to="/edit-note">Create Note</Link>
          </li>
        </ul>


      </nav>

      <Outlet />
    </>
  )
};

export default Layout;